export enum WarmLeadQualificationEnum {
  Rehau = 'rehau',
  Installer = 'installer',
}
